import React from 'react';
import {Result, Spin} from 'antd';
import logo from "../../assets/btcLogoBlau.png";
import {COLORS} from "../../utils/Colors";

const KeycloakErrorPage = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', backgroundColor: COLORS.btcPrimaryGrey }}>
            <img src={logo} alt="Logo" style={{ width: 150, marginBottom: 20, marginLeft: 15 }} />
            <Result
                status="error"
                title="Verbindungsfehler"
                subTitle="Es konnte keine Verbindung zu Keycloak hergestellt werden."
            />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Spin />
                <div style={{ marginTop: 10 }}>Loading</div>
            </div>
        </div>
    );
};

export default KeycloakErrorPage;
